import { Typography } from '@mui/material'
import * as S from './Content.styles'

interface ContentProps {
  text: string;
  children: React.ReactNode;
}

const Content: React.FC<ContentProps> = ({ text, children }) => (
  <S.Container>
    <Typography>{text}</Typography>
    {children}
  </S.Container>
)

export default Content
